// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"525fb711","732":"e39d7753","977":"6a0c4e8a"}[chunkId] + ".chunk.js";
};